import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast, { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../common/ModelDelete";
import ModelBulkUpload from "../../common/ModelBulkUpload";
import { AddButton, EditButton, DeletButton } from "../../common/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import OffcanvasCon from "../../OffcanvasCon/OffcanvasCon";
import DataTable from "datatables.net";
import { formatDateToIST, IDS } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import DatePicker from "react-datepicker";
// import search1 from "../../../assets/icons/search.png";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    Per_Page_Dropdown,
    postData,
    getDownloadDataExcel,
    isAllow,
    IMG_URL,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [showoff, setShowoff] = useState(false);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [searchDate, setSearchDate] = useState("");

  const [searchDateTo, setSearchDateTo] = useState();
  const [searchDateFrom, setSearchDateFrom] = useState();
  const [searchCustomer, setSearchCustomer] = useState("");

  const [searchStartTime, setSearchStartTime] = useState();
  const [searchEndTime, setSearchEndTime] = useState();
  const getDataAll = async () => {
    const response = await getData(
      `/admin/subscription-order/order?page=${onPageChange || 1}&per_page=${
        perPage || 5
      }&term=${search || ""}&from=${searchDateFrom || ""}&to=${
        searchDateTo || ""
      }&start_time=${searchStartTime || ""}&end_time=${
        searchEndTime || ""
      }&customer=${searchCustomer || ""}`
    );
    await setData(response);
    setCurrentPage(response?.data?.current_page);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.total_pages);

    setOption(await Per_Page_Dropdown(response?.data?.total));

    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, show, show1, onPageChange]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>
    );
  }

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/admin/customer/${id}`);
    setChangeStatus(response);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/admin/customer/${recordToDeleteId}`);
      // notify("error", "Deleted Succefully");

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
    col11: true,
    col12: true,
    col13: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const BulkUpload = async (e) => {
    try {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      const response = await postData("/admin/customer/bulk", formData, {});
      if (response?.success) {
        setShowModal({ code: response.code, message: response.message });
      } else {
        setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        setShowoff(response?.data);
      }, 1000);
      getDataAll();
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const Sample = async (e) => {
    try {
      await getDownloadDataExcel("/admin/customer/sample", {}, "Category");
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  useEffect(() => {
    const table = new DataTable("#example");
    return () => {
      table.destroy();
    };
  }, []);

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        // await DownloadExcel(
        //   // "/download-excel/download-users",
        //   `/download-excel/download-users?term=${search || ""}&mobile=${mobile || ""}&from=${from || ""}&to=${to || ""}`,
        //   "Users List"
        // );
        await getDownloadDataExcel(
          `/admin/subscription-order/order?term=${search || ""}&from=${
            searchDate || ""
          }&to=${searchDateTo || ""}`,
          null,
          "Subscription Order List"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Subscription Order"} link={"/admin/customer"} />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels tab-radio tab-radio mt-3">
                <div className="">
                  {/* container */}
                  <div className="row">
                    {/* <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12">
                        <div className="add me-3">
                          {isAllow.includes(IDS.Brand.Add) ? (
                            <Link
                              // to="/admin/customer/add"
                              type="button"
                              className="btn btn-add pe-3"
                            >
                              <div onClick={() => handleShow()}>
                                <img
                                  src={plus}
                                  className="plus me-2 ms-0"
                                  alt=""
                                />
                                Add Brand
                              </div>
                            </Link>
                          ) : (
                            <></>
                          )}
                        </div> 
                    </div>*/}
                    {/* <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12 mt-lg-0 mt-md-2 mt-2">
                      <div className="add me-3">
                        <div className="dropdown">
                          <button
                            className="btn btn-columns dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <img
                              src={colunms}
                              className="columns me-2 "
                              alt=""
                            />
                            Column Selection
                            <img src={top} className="top ms-1" alt="" />
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col1")}
                                href="#"
                              >
                                Sr. No.
                                {visible?.col1 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col2")}
                                href="#"
                              >
                                Name
                                {visible?.col2 ? (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>{" "}
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col3")}
                                href="#"
                              >
                                Email
                                {visible?.col3 ? (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col4")}
                                href="#"
                              >
                                Contact No
                                {visible?.col4 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col5")}
                                href="#"
                              >
                                Gender
                                {visible?.col5 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col6")}
                                href="#"
                              >
                                Image
                                {visible?.col6 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col7")}
                                href="#"
                              >
                                Last Login
                                {visible?.col7 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col8")}
                                href="#"
                              >
                                Status
                                {visible?.col8 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col9")}
                                href="#"
                              >
                                Action
                                {visible?.col9 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) =>
                                  toggleColumn(event, "col11")
                                }
                                href="#"
                              >
                                Order
                                {visible?.col11 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) =>
                                  toggleColumn(event, "col12")
                                }
                                href="#"
                              >
                                Address
                                {visible?.col12 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div> */}

                    <div className="border-line mt-3"></div>
                    <div className="row mt-4">
                      <div className=" col-12">
                        <div className="d-flex align-items-center mb-3">
                          <div className="show me-2">
                            <p className="show m-0">Show</p>
                          </div>
                          <div className="number me-2">
                            <select
                              className="form-select form-select-sm"
                              aria-label=".form-select-sm example"
                              onChange={(e) => {
                                setonPageChange(1);
                                setperPage(e.target.value);
                              }}
                            >
                              {option?.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="entries">
                            <p className="show m-0">entries</p>
                          </div>
                          <div className="sowing ms-3 me-2">
                            <p className="show m-0">{`Showing ${Math.min(
                              (currentPage - 1) * perPage + 1
                            )} to ${Math.min(
                              currentPage * perPage,
                              data?.data?.total
                            )} of ${data?.data?.total} entries`}</p>
                          </div>
                        </div>
                      </div>
                      <div className="   col-12">
                        <div className="row align-items-end mb-3">
                          <div className="col-12 mb-2">
                            <div className="row">
                              {/* <div className="col-md-3">
                                <div className="num">
                                  <Form.Label></Form.Label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id=""
                                    value={search}
                                    placeholder="Search Customer"
                                    onChange={(e) => {
                                      setSearch(e.target.value);
                                    }}
                                  />
                                </div>
                              </div> */}
                              <div className="quick-filters mt-3">
                                <span className="quick-filters__label">
                                  <b>Quick Filters:</b>
                                </span>
                                <div className="quick-filters__tabs mt-3">
                                  <div className="row">
                                    <div className="col-md-3">
                                      <div className="num me-2">
                                        <label className="form-label">
                                          Start Date
                                        </label>
                                        <input
                                          type="date"
                                          className="form-control"
                                          placeholder="from"
                                          value={searchDateFrom}
                                          onChange={(e) => {
                                            setSearchDateFrom(e.target.value);
                                            setonPageChange(1);
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="col-md-3">
                                      <div className="num me-2">
                                        <label className="form-label">
                                          End Date
                                        </label>
                                        <input
                                          type="date"
                                          className="form-control"
                                          placeholder="to"
                                          value={searchDateTo}
                                          onChange={(e) => {
                                            setSearchDateTo(e.target.value);
                                            setonPageChange(1);
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-3 mb-2">
                                      <Form.Label>Product Name</Form.Label>
                                      <Form.Control
                                        placeholder="Enter Product Name"
                                        type="text"
                                        className="form-control"
                                        id=""
                                        value={search}
                                        onChange={(e) => {
                                          setSearch(e.target.value);
                                        }}
                                      />
                                    </div>
                                    <div className="col-lg-3 mb-2">
                                      <Form.Label>Customer Name</Form.Label>
                                      <Form.Control
                                        placeholder="Enter Customer Name"
                                        type="text"
                                        className="form-control"
                                        id=""
                                        value={searchCustomer}
                                        onChange={(e) => {
                                          setSearchCustomer(e.target.value);
                                        }}
                                      />
                                    </div>
                                    <div className="col-xxl-1 col-xl-1  col-lg-1 col-md-1">
                                      <div className="Search me-2">
                                        <Form.Label>Search</Form.Label>
                                        <Button
                                          type="button"
                                          onClick={getDataAll}
                                          className="btn btn-search"
                                        >
                                          <img
                                            src={search1}
                                            className="search"
                                            alt=""
                                          />
                                        </Button>
                                      </div>
                                    </div>
                                    <div className="col-xxl-1 col-xl-1  col-lg-2 col-md-2">
                                      <div className="Search-1">
                                        <Form.Label>Reset</Form.Label>
                                        <button
                                          type="button"
                                          onClick={() => {
                                            setSearch("");
                                            setSearchDateFrom("");
                                            setSearchDateTo("");
                                            setSearchEndTime("");
                                            setSearchStartTime("");
                                            setSearchCustomer("");
                                            setReset(!reset);
                                          }}
                                          className="btn btn-reset"
                                        >
                                          Reset
                                        </button>
                                      </div>
                                    </div>
                                     <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
                                      <Form.Label> Download Excel</Form.Label>
                                      <div>
                                        <button
                                          className="btn btn-success mt-2"
                                          type="button"
                                          onClick={HandleDownload}
                                        >
                                          Excel
                                          <FontAwesomeIcon
                                            icon="fa-solid fa-file-lines"
                                            className="ms-2"
                                          />
                                        </button>
                                      </div>
                                    </div>
                                    {/* <div className="col-md-3">
                                      <label className="form-label">
                                        Start Time
                                      </label>
                                      <DatePicker
                                        selected={searchStartTime}
                                        onChange={(date) => {
                                          setSearchStartTime(date);
                                          setonPageChange(1);
                                        }}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        timeCaption="Start Time"
                                        dateFormat="h:mm aa" // 12-hour format
                                        className="form-control"
                                      />
                                    </div>

                                    <div className="col-md-3">
                                      <label className="form-label">
                                        End Time
                                      </label>
                                      <DatePicker
                                        selected={searchEndTime}
                                        onChange={(date) => {
                                          setSearchEndTime(date);
                                          setonPageChange(1);
                                        }}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        timeCaption="End Time"
                                        dateFormat="h:mm aa"
                                        className="form-control"
                                      />
                                    </div> */}
                                   

                                    {/* <div className="col-lg-3 mb-2">
                                            <Form.Label>Select Category </Form.Label>
                                            <Select
                                              isSearchable
                                              options={categories}
                                              value={searchCategory}
                                              placeholder="Select Category"
                                              onChange={(e) => {
                                                setSearchCategory(e);
                                                getAllSubCategories(e.value);
                                                setSearchSubCategory("");
                                              }}
                                              classNamePrefix="searchProduct"
                                            />
                                          </div>
                              
                                          <div className="col-lg-3 mb-2">
                                            <Form.Label>Select Sub Category </Form.Label>
                                            <Select
                                              isSearchable
                                              options={subCategories}
                                              value={searchSubCategory}
                                              placeholder="Select Sub Category"
                                              onChange={(e) => {
                                                setSearchSubCategory(e);
                                                getAllChildCategories(e.value);
                                              }}
                                              classNamePrefix="searchProduct"
                                            />
                                          </div>
                              
                                          <div className="col-lg-3 mb-2">
                                            <Form.Label>Select Child Category </Form.Label>
                                            <Select
                                              isSearchable
                                              options={childCategories}
                                              value={searchChildCategory}
                                              placeholder="Select Child Category"
                                              onChange={(e) => {
                                                setSearchChildCategory(e);
                                              }}
                                              classNamePrefix="searchProduct"
                                            />
                                          </div> */}
                                  </div>
                                </div>
                              </div>
                              {/* <div className="row align-items-end mb-3">
                                <div className="col-12 mb-2">
                                  <div className="row">
                                    
                                  </div>
                                </div>
                              </div> */}

                              {/* <div className="col-md-3">
                                <div className="num me-2">
                                  <label className="form-label">
                                    Start Date
                                  </label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    placeholder="from"
                                    value={searchDate}
                                    onChange={(e) => {
                                      setSearchDate(e.target.value);
                                      setonPageChange(1);
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-md-3">
                                <div className="num me-2">
                                  <label className="form-label">End Date</label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    placeholder="to"
                                    value={searchDateTo}
                                    onChange={(e) => {
                                      setSearchDateTo(e.target.value);
                                      setonPageChange(1);
                                    }}
                                  />
                                </div>
                              </div> */}
                            </div>
                          </div>                         

                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div>
                    <div></div>
                    <div>
                      <strong>Total Kg:</strong>{" "}
                      {Number(data?.data?.total_weight || 0).toFixed(2)} kg
                    </div>
                  </div> */}

                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr className="">
                            {visible.col1 && (
                              <th className="sr" style={{ width: "10%" }}>
                                Sr. No.
                              </th>
                            )}
                            {visible.col13 && (
                              <th className="sr" style={{ width: "10%" }}>
                                Subscription Name
                              </th>
                            )}
                            {visible.col10 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Order Date{" "}
                              </th>
                            )}
                            {visible.col2 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Product Name{" "}
                              </th>
                            )}
                            {visible.col8 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Customer Name{" "}
                              </th>
                            )}
                            {visible.col3 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Quantity(kg){" "}
                              </th>
                            )}
                            {visible.col4 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Serving Size{" "}
                              </th>
                            )}
                            {visible.col5 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Calories{" "}
                              </th>
                            )}
                            {visible.col6 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Image{" "}
                              </th>
                            )}
                            {visible.col7 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Create Date{" "}
                              </th>
                            )}
                            {/* {visible.col11 && (
                              <th className="sr" style={{ width: "10%" }}>
                                Order
                              </th>
                            )}

                            {visible.col12 && (
                              <th className="sr" style={{ width: "10%" }}>
                                Address
                              </th>
                            )}
                            {visible.col8 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Status
                              </th>
                            )}
                            {visible.col9 && (
                              <th className="active" style={{ width: "10%" }}>
                                Action
                              </th>
                            )} */}
                          </tr>
                        </thead>
                        <tbody>
                          {data?.data?.data?.map((d, index) => {
                            const paginatedIndex =
                              (onPageChange - 1) * perPage + index + 1;
                            return (
                              <tr className="" key={index}>
                                {visible.col1 && <td>{paginatedIndex}.</td>}
                                {visible.col13 && (
                                  <td>{d.Subscription?.plan_name}</td>
                                )}
                                {visible.col10 && (
                                  <td>
                                    {formatDateToIST(
                                      d.Subscription_Delivery_Detail?.date
                                    )}
                                    <div>
                                      {
                                        d?.Subscription_Delivery_Detail
                                          ?.Time_Slot?.from
                                      }
                                      -
                                      {
                                        d?.Subscription_Delivery_Detail
                                          ?.Time_Slot?.to
                                      }
                                    </div>
                                  </td>
                                )}
                                {visible.col2 && <td>{d?.Product?.name}</td>}
                                {visible.col8 && (
                                  <td>{d?.Subscription?.User?.name}</td>
                                )}
                                {visible.col3 && <td>{d?.quantity}</td>}
                                {visible.col4 && <td>{d?.serving_size}</td>}
                                {visible.col5 && <td>{d?.calories}</td>}
                                {visible.col6 && (
                                  <td>
                                    {d?.Product?.image && (
                                      <img
                                        className="product-image"
                                        src={IMG_URL + d?.Product?.image}
                                        alt="Image"
                                        width="100"
                                        height="100"
                                      />
                                    )}
                                  </td>
                                )}
                                {visible.col7 && (
                                  <td>
                                    {formatDateToIST(d?.updatedAt)}
                                    {/* <div>
                                      {calculateTimeAgo(d?.createdAt)}
                                    </div>
                                    <div>
                                      {formatTimeInIST(d?.createdAt)}
                                    </div> */}
                                  </td>
                                )}
                                {/* {visible.col11 && (
                                  <td>
                                    {Array.isArray(d?.Product_Order)
                                      ? d.Product_Order.length
                                      : 0}
                                  </td>
                                )}
                                {visible.col12 && <td>{d?.User_Address?.building}</td>}

                                {visible.col8 && (
                                  <td>
                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        checked={d.status}
                                        disabled={!isAllow?.includes(51)}
                                        onChange={() => {
                                          ChangeStatus(d.id);
                                        }}
                                        id={`flexSwitchCheckDefault${d?.id}`}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`flexSwitchCheckDefault${d?.id}`}
                                      >
                                        {d.status ? "Active" : "Inactive"}
                                      </label>
                                    </div>
                                  </td>
                                )}
                                {visible.col9 && (
                                  <td>
                                    <div className="d-flex">
                                      {isAllow.includes(IDS.Customer.List) ? (
                                        <Button
                                          onClick={() => handleShow1(d?.id)}
                                          type="button"
                                          className="btn btn-primary me-1"
                                        >
                                          <FontAwesomeIcon icon="fa-solid fa-eye" />
                                        </Button>
                                      ) : (
                                        <></>
                                      )}
                                      {isAllow.includes(IDS.Customer.Delete) ? (
                                        <DeletButton
                                          showDeleteRecord={showDeleteRecord}
                                          id={d?.id}
                                          name={d?.name}
                                        />
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </td>
                                )} */}
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      {data && data?.data?.data?.length > 0 ? (
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      ) : (
                        <p className="no-datashow">Sorry, No Data Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />

      <ModelBulkUpload
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <Toaster position="top-right" />

      <OffcanvasCon show={showoff} handleClose={() => setShowoff(false)} />
    </>
  );
};

export default Tables;
